import { TiktokInfluencerPostApiBody } from '../types/Tiktok.types';
import { fetchWithToken, TiktokInfluencerPost, toFormDataRequest } from '@round/api';
import { ApiResponse, ApiResponseError } from '../../../../utility/utility.types';
import { WithAllUnionKeys } from '@round/utils';

export type TiktokPatchErrorData = WithAllUnionKeys<ApiResponseError<TiktokInfluencerPostApiBody>> & {
    fee_config_id?: string[];
    non_field_errors?: string[];
};

type PatchTiktokInfluencerPostResponse =
    | ApiResponse<TiktokInfluencerPost, 200>
    | ApiResponse<TiktokPatchErrorData, 400>;

export async function patchTiktokInfluencerPost(
    postId: number,
    post: Partial<TiktokInfluencerPostApiBody>
): Promise<PatchTiktokInfluencerPostResponse> {
    const paymentInfo = 'payment_info' in post ? JSON.stringify(post.payment_info) : undefined;

    const response = await fetchWithToken(
        `/api/advertising/viewsets/tiktok-influencer-post/${postId}/`,
        toFormDataRequest(
            {
                method: 'PATCH',
                body: { ...post, payment_info: paymentInfo },
            },
            ({ body }) => 'payment_request_file_upload' in body && body.payment_request_file_upload !== undefined
        )
    );

    if (response.status === 400) {
        return {
            status: 400,
            data: await response.json(),
        };
    }

    if (!response.ok) {
        throw new Error(`Could not PATCH tiktok influencer post: ${postId}`);
    }

    return {
        status: 200,
        data: await response.json(),
    };
}

export async function deleteTiktokInfluencerPost(postId: number): Promise<ApiResponse<undefined, 204>> {
    const response = await fetchWithToken(`/api/advertising/viewsets/tiktok-influencer-post/${postId}/`, {
        method: 'DELETE',
    });

    if (!response.ok) {
        throw new Error(`Could not delete tiktok influencer post ${postId}`);
    }

    return {
        status: 204,
        data: undefined,
    };
}
